export enum TimeUnit {
  Minute = 'minute',
  Hour = 'hour',
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

export interface RelativeDate {
  unit: TimeUnit;
  value: number;
}

export type AbsoluteDate = string;

export type BaseDate = AbsoluteDate|RelativeDate;

export interface ApiDateRange {
  before?: boolean;
  from_date?: BaseDate;
  to_date?: BaseDate;
  window?: RelativeDate;
}

export interface BookmarkDateRange {
  type: DateRangeType;
  from_date: BaseDate;
  to_date: BaseDate;
}

export interface CalendarDateRange {
  from?: AbsoluteDate;
  to?: AbsoluteDate;
}

export enum DateRangeType {
  Between = 'between',
  On = 'on',
  RelativeAfter = 'in the last',
  RelativeBefore = 'before the last',
  Since = 'since',
}

export enum DisplayContext {
  CustomEvent = 'custom_event',
  Default = 'default',
  PropertyFilter = 'property_filter',
  FullLength = 'full_length',
  InsightsTimePicker = 'insights_time_picker',
}
